import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { render } from 'react-dom';
import { App as PropulsionApp } from 'propulsion-rc-v2';
import { PageIdProvider } from '../../shared_modules/local-propulsion/components';
import PI1 from './PI1.jsx';
import '../../shared_modules/local-propulsion';
import LiveAriaContextWrapper from '@shared_modules/live-aria-a11y/LiveAria';

render(
  <BrowserRouter basename="/apply/personal/identity">
    <LiveAriaContextWrapper>
      <Route
        path="/"
        render={props => (
          <PageIdProvider appProvider={PropulsionApp}>
            <PI1 {...props} />
          </PageIdProvider>
        )}
      />
    </LiveAriaContextWrapper>
  </BrowserRouter>,
  document.getElementById('pi1-1QAAT')
);

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pi1-1QAAT.scss');